export enum EntityAbilitySlot {
  BASIC = "basic",
  SPECIAL = "special",
  ULTIMATE = "ultimate",
  ASSIST_AND_COUNTER = "assist_and_counter",
}

export type EntityAbility = { level: number; ability: string; unlocked: boolean; slot: EntityAbilitySlot }

export type EntityStats = {
  block_amount: number
  block_chance: number
  crit_amount: number
  crit_chance: number
  dodge_chance: number
  focus: number
  resistance: number
  accuracy: number
}

export type EntityCorporation = "faraday" | "hyperion" | "tormund"

export type EntityStatus = "active" | "in_team" | "in_marketplace" | "in_rent" | "burned"

export type Entity = {
  abilities: EntityAbility[]
  armor: number
  archetype: string
  corporation: EntityCorporation
  damage: number
  dna: string
  is_broken: boolean
  durability: number
  generation: number
  durability_damage: number
  health: number
  id: string
  inserted_at: string // date
  metadata: unknown // {}
  owner: string
  power: number
  seed: number
  skin: string
  speed: number
  stats: EntityStats
  status: EntityStatus
  synergy: number | boolean
  token_id: number
  cooldown: string // date
  reveal_cooldown?: string // date
  fix_cooldown?: string //date
  rent_cooldown?: string //date
  transfer_cooldown?: string
  updated_at: string // date
}
